<template>
  <div 
    class="mt-8">
    <v-dialog v-model="dialog.customer"
      @keydown.esc="dialog.customer = false"
      :fullscreen="dialog.fullscreen"
      width="1200"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Tambahkan Produk

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.customer = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.customer = false;"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mt-3">
          <div 
            class="fs-15 label-input">
            Nama Product
          </div>

          <v-autocomplete
            
            filled
            rounded
            dense
            solo
            v-on:change="addVarian()"

            color="#718EBF"
            placeholder="Nama Product"

            
            :items="product"
            item-value="id"
            item-text="name"
            :item-color="set_color"

            v-model="product_id"
            style="border-radius: 10px;">
          </v-autocomplete>
          <v-data-table
            v-model="selected"
            :headers="headers"
            ref="table-grid"
            class="table-grid"
            :items="list"
            height="calc( 100vh - 400px )"
            elevation="0"
            hide-default-footer
            :single-select="false"
            item-key="id"
            show-select
            :items-per-page="1000000000"
            style="border: 1px solid #E7E7E7;"
          >
          </v-data-table>
        </v-card-text>
        

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="toAdd()"
            :loading="process.delete"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Pilih
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat
            class="ma-4 mt-0 pb-5"
            style="border-radius: 10px;">
            <v-card-text>
              <div class="color-dark-blue fs-22 font-weight-bold">
                Mengubah Strata Harga
              </div>
    
              <v-row
                class="">
                <v-col 
                  cols="12"
                  class="px-0">
                  <v-card 
                    flat
                    style="background: transparent;">
                    <v-card-text>
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <v-row>
                            <v-col
                              cols="12"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Nama" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Nama
                                </div>
            
                                <v-text-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Nama"
            
                                  
            
                                  v-model="form.name"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              md="12" class="pt-0">
                              <!-- <ValidationProvider
                                name="Persentase Strata Harga" 
                                rules="" 
                                v-slot="{ errors }"> -->
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Deskripsi
                                </div>
            
                                <v-textarea
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Deskripsi"
  
                                  
            
                                  v-model="form.desc"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-textarea>
                              <!-- </ValidationProvider> -->
                            </v-col>
                            <v-col
                              cols="12" md="6" class="pt-0">
                              <ValidationProvider
                                name="Qty minimum" 
                                rules="required|min_value:0" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Qty Minimum
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Qty minimum"
            
                                  v-model="form.min"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col
                              cols="12" md="6" class="pt-0">
                              <ValidationProvider
                                name="Qty Maksimum" 
                                rules="required|min_value:0" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Qty Maksimum
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Qty Maksimum"
            
                                  v-model="form.max"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12" md="6" class="pt-0">
                              <ValidationProvider
                                name="Nominal" 
                                rules="required|min_value:0" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Nominal
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Nominal"
            
                                  v-model="form.nominal"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12" md="6" class="pt-0">
                              <ValidationProvider
                                name="Kuota" 
                                rules="required|min_value:0" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Kuota
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Kuota"
            
                                  v-model="form.quota"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <ValidationProvider
                                name="Kode Sales" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Kode Sales
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="kode_sales"
                                  item-value="id"
                                  item-text="name"
                                  v-on:change="filterToko()"
            
                                  color="#718EBF"
                                  placeholder="Kode Sales"
            
                                  
            
                                  v-model="form.sales_region_id"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="pt-0">
                              <ValidationProvider
                                name="Produk" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Produk
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="list"
                                  item-value="id"
                                  :item-text="item => `${item.product_name} - ${item.name}`"
            
                                  color="#718EBF"
                                  placeholder="Produk"
                                  v-model="form.varian_id"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:selection="{ item }">
                                    <div>
                                      {{ item.product_name }} - {{ item.name }}
                                    </div>
                                  </template>

                                  <template v-slot:item="{ item }">
                                    <div>
                                      {{ item.product_name }} - {{ item.name }}
                                    </div>
                                  </template>

                                  <!-- <template v-slot:item="{ item }">
                                    <div class="d-flex align-center">
                                      <div>
                                        <v-checkbox
                                          :input-value="form.varian_id.includes(item.id)"
                                        ></v-checkbox>
                                      </div>
                                      <div>
                                        {{ item.product_name }} - {{ item.name }}
                                      </div>
                                    </div>
                                  </template> -->
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                              <!-- <div class="d-flex align-center" style="width: 100%">
                                <div style="width: 90%;">
                                  <ValidationProvider
                                    name="Nama Toko" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <div 
                                      class="fs-15 label-input">
                                      
                                      Nama Toko
                                    </div>
                                    <v-autocomplete
                                      v-on:keydown.enter.prevent="save()"
                                      
                                      filled
                                      rounded
                                      dense
                                      solo
                                      :items="toko"
                                      item-value="id"
                                      item-text="name"
                                      multiple
                                      :readonly="form.sales_region_id === ''"
                
                                      color="#718EBF"
                                      placeholder="Nama Toko"
                                      v-model="form.store_array"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;">
                                      <template v-slot:selection="{ item }">
                                        <div>
                                          <v-chip
                                            v-if="item.id !== ''"
                                            class="ma-1"
                                            :key="item.id"
                                            close
                                            @click:close="form.store_array = form.store_array.filter(i => i !== item.id)"
                                          >
                                            {{ item.name }}
                                          </v-chip>
                                        </div>
                                      </template>
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </div>
                                <div style="width: 10%;" class="pl-4 pt-2">
                                  <v-btn
                                    @click="form.store_array = []; form.store_array = toko.map(item => item.id);"
                                    width="100%"
                                    height="50"
                                    :disabled="toko.length < 1 || (form.sales_region_id === '')"
                                    elevation="0"
                                    color="#1814F3"
                                    style="border-radius: 6px;"
                                    class="fs-16 white--text text-capitalize">
                                    Semua
                                  </v-btn>
                                </div>
                              </div> -->


                              <div 
                                class="fs-15 label-input mb-3">
                                Nama Toko
                              </div>

                              <div v-if="form.sales_region_id !== ''" class="mt-2 mb-3">
                                <v-text-field
                                  @click:clear="search = ''; fetchToko();"
                                  v-on:keyup.enter="fetchToko()"

                                  filled
                                  rounded
                                  dense
                                  single-line

                                  hide-details
                                  :color="set_color"
                                  placeholder="Cari data yang Anda butuhkan . . ."
                                  append-icon="mdi-magnify"
                                  clearable

                                  v-model="search"
                                  class="fs-12 little-placeholder"
                                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 100%">
                                </v-text-field>
                              </div>

                              <v-card-text
                                v-if="form.sales_region_id === ''"
                                class="pb-0 my-4" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                                <div class="text-center">
                                  <v-img 
                                    class="mx-auto"
                                    contain
                                    alt="vuetify"
                                    :width="90"
                                    :height="90"
                                    :src="require('@/assets/image/empty.png')">
                                    <!-- <template v-slot:placeholder>
                                      <v-row
                                        class=" "
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template> -->
                                  </v-img>
                                  <div class="mt-3 fs-16">
                                    SIlahkan Pilih Kode Sales Terlebih Dahulu
                                  </div>
                                </div>
                              </v-card-text>

                              <div v-else>
                                <div v-if="!process.load">
                                  <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                    <tr>
                                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                        <v-checkbox
                                          :input-value="isAllSelected"
                                          :indeterminate="isIndeterminate"
                                          @change="toggleSelectAll"
                                        />
                                      </th>
                                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                        Kode Outlet
                                      </th>
                                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                        Nama Toko
                                      </th>
                                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                        Nama Customer
                                      </th>
                                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                        Alamat
                                      </th>
                                    </tr>
                                    <tr v-for="(item, index) in toko" :key="index">
                                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                        <v-checkbox
                                          v-model="form.store_array"
                                          :value="item.id"
                                        ></v-checkbox>
                                      </td>
                                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                        {{ item.customer_code }}
                                      </td>
                                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                        {{ item.name }}
                                      </td>
                                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                        {{ item.customer_name }}
                                      </td>
                                      <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                        {{ item.province_name }}, {{ item.city_name }}, {{ item.subdistrict_name }}, {{ item.village_name }}
                                      </td>
                                    </tr>
                                  </table>
                                </div>
  
                                <v-card-text
                                  v-if="process.load" 
                                  class="pb-0 my-4" 
                                  style="height: 300px; display: flex; align-items: center; justify-content: center;">
                                  <div class="text-center">
                                    <div class="mb-4 title">
                                      Mohon Tunggu . . .
                                    </div>
  
                                    <v-progress-linear
                                      :color="set_color"
                                      indeterminate
                                      rounded
                                      height="10">
                                    </v-progress-linear>
                                  </div>
                                </v-card-text>
  
                                <v-card-text
                                  v-if="!process.load && toko.length === 0"
                                  class="pb-0 my-4" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                                  <div class="text-center">
                                    <v-img 
                                      class="mx-auto"
                                      contain
                                      alt="vuetify"
                                      :width="90"
                                      :height="90"
                                      :src="require('@/assets/image/empty.png')">
                                      <!-- <template v-slot:placeholder>
                                        <v-row
                                          class=" "
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            indeterminate 
                                            :color="set_color">
                                          </v-progress-circular>
                                        </v-row>
                                      </template> -->
                                    </v-img>
                                    <div class="mt-3 fs-16">
                                      Belum Ada Data
                                    </div>
                                  </div>
                                </v-card-text>
                              </div>
                            </v-col>
                          </v-row>
                          <!-- <div
                            class="mb-4">
                            <div 
                              class="body-2 mb-2">
                              Poto Profil
                            </div>
    
                            <uploadfolder v-if="form.image_url === ''"
                              v-model="upload.image">
                              <div 
                                slot="activator">
                                <v-card 
                                  flat
                                  width="200"
                                  height="200"
                                  class="d-flex align-center justify-center cursor-pointer"
                                  style="border-radius: 15px;
                                        border: 2px solid #EBEBEB; 
                                        border-style: dashed;">
                                  <v-avatar v-if="!process.image"
                                    v-ripple
                                    tile 
                                    width="200"
                                    height="200">
                                    <v-icon
                                      size="50"
                                      color="#B9B9B9">
                                      mdi-cloud-upload-outline
                                    </v-icon>
                                  </v-avatar>
    
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-card>
                              </div>
                            </uploadfolder>
    
                            <v-card v-if="form.image_url !== ''"
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar
                                v-ripple
                                tile 
                                size="200"
                                style="border-radius: 15px;">
                                <v-img 
                                  contain
                                  width="100%"
                                  height="100%"
                                  alt="Mitra Warung" 
                                  :src="form.image_url"
                                  class="ma-auto"
                                  style="border-radius: 15px;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>
    
                              <v-icon 
                                @click="form.image_url = ''"
                                color="red"
                                class="cursor-pointer"
                                style="position: absolute; top: -10px; right: -10px;">
                                mdi-close-circle
                              </v-icon>
                            </v-card>
                          </div> -->
    
    
    
                        </v-form>
                      </ValidationObserver>
    
                      <div v-if="message.error.length > 0"
                        class="text-center my-4 d-flex align-center">
                        <div
                          class="error--text">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
    
              <v-row
                justify="end"
                class="pa-4 pr-1">
                <v-col 
                  cols="12"
                  md="12"
                  class="d-flex align-center justify-end py-0">
                  <v-btn 
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form"
                    width="190"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Simpan
                  </v-btn>
                  
                  <v-btn
                    @click="$router.go(-1)"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    width="140"
                    height="45"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                    style="font-weight: 600;">
                  
                      Batal
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          customer: false,
          fullscreen: false
        },
        markers: [],
        sales: [],
        toko: [],
      place: null,
        form: {
          id: '',
          name: '',
          desc: '',
          min: '',
          max: '',
          nominal: '',
          quota: '',
          sales_region_id: '',
          varian_id: '',
          store_array: [],
        },
        kode_sales: [],
        search: '',

        lastIndex: 1,
        sales_region_id: '',
        product: [],
        product_id: '',
        selected: [],
        headers: [
                // {
                //   text: 'No',
                //   width: '80',
                //   value: 'index',
                //   freeze: true,
                //   hide: false
                // },
                {
                  text: 'Nama',
                  width: '150px',
                  value: 'name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'SKU',
                  width: '180px',
                  value: 'sku',
                  freeze: false,
                  hide: false
                },
              
              ],
        category: [
          { id: 'kode_sales', name: 'Kode Sales' },
          { id: 'tipe_toko', name: 'Tipe Toko' },
          { id: 'area', name: 'Area' }
        ],
        list: [],
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        customer: [],
        sales: [],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        menu3: false,
        grand_total: 0,

        // selected: {
        //   row: [],
        //   freeze: [],
        //   delete: [],

        //   menu: 'Koordinat'
        // },

        map: null,
        allToko: [],

        center: {
          lat: -6.1805, 
          lng: 106.8284
        },

        upload: {
          images: null
        },

        process: {
          form: false,

          file: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              // this.upload.images.map(obj => {
                this.form.images.push(
                  this.upload.images.fileuri
                )
              // })

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      isAllSelected() {
        return this.form.store_array.length === this.toko.length && this.toko.length > 0;
      },
      isIndeterminate() {
        return this.form.store_array.length > 0 && this.form.store_array.length < this.toko.length;
      },
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers_data.filter(header => !header.hide)  
      },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      toggleSelectAll() {
        if (this.isAllSelected) {
          this.form.store_array = [];
        } else {
          this.form.store_array = this.toko.map(item => item.id);
        }
      },
      async fetchDetail () {
          this.process.load = true
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/strata_price/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.detail = res.results.data
              this.form = {
                id: this.detail.id,
                name: this.detail.name,
                desc: this.detail.desc,
                min: this.detail.min*1,
                max: this.detail.max*1,
                nominal: this.detail.nominal*1,
                quota: this.detail.quota*1,
                sales_region_id: this.detail.sales_region_id,
                varian_id: this.detail.varian_id,
                store_array: [],
              }
              res.results.data.price_strata_store.map(obj => {
                this.form.store_array.push(obj.store_id)
              })
              this.fetchToko()
              this.fetchProduct()
              this.fetchVarian()
              this.fetchKodeSales()
            }
          })
        },
      async fetchToko () {
        // this.process.load = true

        let params = {
          limit: 1000000,
          sales_region_id: this.form.sales_region_id,
          province_name: this.form.province_name,
          city_name: this.form.city_name,
          subdistrict_name: this.form.subdistrict_name,
          type: this.form.tipe_toko,
          status:'approved',
          is_blacklist: '0',
          search: this.search,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/toko/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.toko = res.results.data
            this.allToko = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchKodeSales() {

        let params = {
          limit: 10000000000000
        }

        await get(`admin/sales_region/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.kode_sales = res.results.data
          }
        })
      },
      async fetchProv() {

       let params = {
        limit: 10000000000000
      }

      await get(`ref/provinsi`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.province = res.results.data
        }
      })
    },

    changeProvince() {
      this.form.city_id = ''
      this.form.sub_district_id = ''
      this.form.city_name = ''
      this.form.subdistrict_name = ''
      let id = this.form.province_id
      this.form.province_name = this.form.province_id === null || this.form.province_id === '' ? '' : this.province.find(obj => obj.id === id).name
      this.fetchCity(id)
      this.filterToko()
    },

    async fetchCity(id) {

       let params = {
        limit: 10000000000000,
        province_id: id
      }

      await get(`ref/kota`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.city = res.results.data
        }
      })
    },
    changeCity() {
      this.form.sub_district_id = ''
      this.form.subdistrict_name = ''
      let id = this.form.city_id
      this.form.city_name = this.form.city_id === null || this.form.city_id === '' ? '' : this.city.find(obj => obj.id === id).name
      this.fetchSub(id)
      this.filterToko()
    },
    // changeCity() {
    //   this.form.subdistrict_name = ''
    //   let id = ''
    //   this.city.map(obj => {
    //     if (obj.name === this.form.city_name) {
    //       id = obj.id
    //     }
    //   })
    //   this.fetchSub(id)
    // },

    async fetchSub(id) {

       let params = {
        limit: 10000000000000,
        city_id: id
      }

      await get(`ref/kecamatan`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.subdistrict = res.results.data
        }
      })
    },
    filterToko() {
      this.toko = []
      this.form.store_array = []
      this.fetchToko()
      // this.toko = []
      // if(this.form.province_name !== '' && this.form.city_name !== '' && this.form.subdistrict_name !== '' && this.form.province_name !== null && this.form.city_name !== null && this.form.subdistrict_name !== null) {
      //   this.allToko.map(obj => {
      //     if(obj.province_name === this.form.province_name && obj.city_name === this.form.city_name && obj.subdistrict_name === this.form.subdistrict_name) {
      //       this.toko.push(obj)
      //     }
      //   })
      // } else if(this.form.province_name !== '' && this.form.city_name !== '' && this.form.province_name !== null && this.form.city_name !== null) {
      //   this.allToko.map(obj => {
      //     if(obj.province_name === this.form.province_name && obj.city_name === this.form.city_name) {
      //       this.toko.push(obj)
      //     }
      //   })
      // } else if(this.form.province_name !== '' && this.form.province_name !== null) {
      //   this.allToko.map(obj => {
      //     if(obj.province_name === this.form.province_name) {
      //       this.toko.push(obj)
      //     }
      //   })
      // } else {
      //   this.toko = this.allToko
      // }

      // if(this.form.tipe_toko !== '') {
      //   this.allToko.map(obj => {
      //     if(obj.type === this.form.tipe_toko) {
      //       this.toko.push(obj)
      //     }
      //   })
      // }

      // if(this.form.sales_region_id !== '') {
      //   this.allToko.map(obj => {
      //     if(obj.sales_region_id === this.form.sales_region_id) {
      //       this.toko.push(obj)
      //     }
      //   })
      // }
    },
      async fetchProduct () {
        this.process.load = true

        let params = {
          limit: 1000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.product = res.results.data
            
          }
          this.process.load = false
        })
      },
      addVarian() {
        let list = []
        this.list = []
        this.fetchVarian()
      },
      toAdd() {
        this.form.varian_arr = []
        this.dialog.customer = false
        this.form.varian_arr.push(...this.selected)
        // this.form.varian_arr = this.selected
      },
      async fetchVarian () {
        this.list = []
        // this.process.load = true

        // this.limit = pagination.row

        let params = {
          limit: 100000000000000000
        }

        // admin/services/data
        
        await get(`admin/varian/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'No',
              //   width: '80',
              //   value: 'index',
              //   freeze: true,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '150px',
                value: 'name',
                freeze: true,
                hide: false
              },
              {
                text: 'SKU',
                width: '180px',
                value: 'sku',
                freeze: false,
                hide: false
              },
              {
                text: 'Produk',
                width: '200px',
                value: 'product_name',
                freeze: false,
                hide: false
              },
            
            ]

            this.headers_data = [
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama',
                width: '300px',
                value: 'name',
                freeze: true,
                hide: false
              },
              {
                text: 'SKU',
                width: '180px',
                value: 'sku',
                freeze: false,
                hide: false
              },
              {
                text: 'Produk',
                width: '200px',
                value: 'product_name',
                freeze: false,
                hide: false
              },

              {
                text: '',
                width: '100px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'right',
                format: 'action'
              },
            
            ]
    

            res.results.data.map((item) => {
              this.list.push({
                ...item
              })
            })
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/strata_price/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/promo/strata-harga' })
              // this.$router.go(-1)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>